import React from "react";
import "./PrivacyPolicy.scss";
import img from "./assets/img/privacy_header.png";
import Footer from "./components/Footer";
import MobileFooter from "./components/MobileFooter";

const TermsOfUse = ({ width }) => {
	return (
		<div>
			<section className="privacy-section">
				<div className="privacy-header">
					<div className="privacy-left">
						<h2 className="privacy-policy-title">Terms of Use</h2>
						<p className="privacy-policy-txt">
							Welcome to eFlow Technologies Inc. ("eFlow", "we", "our", "us"). By accessing or using our
							application ("App")—available via Microsoft Teams, Apple App Store (iOS), and Google Play
							(Android)—you agree to comply with and be bound by these Terms of Use (the "Terms").
							Please read them carefully before using the App.
						</p>
					</div>
					<div className="privacy-left">
						<img src={img} alt="Privacy header" />
					</div>
				</div>

				<div className="privacy-container">
					<h3 className="privacy-policy-sub-title">1. Acceptance of Terms</h3>
					<p className="privacy-policy-txt">
						By accessing or using our App on any supported platform, including Microsoft Teams, you agree to these Terms and all applicable laws. If you do not agree, please refrain from using the App.
						We may update these Terms, and any changes will be posted on this page. Continued use implies agreement to the revised Terms.
					</p>

					<h3 className="privacy-policy-sub-title">2. Use of the App</h3>
					<p className="privacy-policy-txt">
						You may use the App only for lawful purposes and in accordance with these Terms. You agree not to:
					</p>
					<ul className="privacy-policy-list">
						<li>Violate any laws or regulations</li>
						<li>Interfere with or restrict others' use of the App</li>
						<li>Exploit the App commercially without authorization</li>
						<li>Use the App for unauthorized or harmful purposes</li>
					</ul>

					<h3 className="privacy-policy-sub-title">3. Account Registration and Security</h3>
					<p className="privacy-policy-txt">
						You're responsible for maintaining the confidentiality of your account credentials. Please notify us promptly if you suspect unauthorized access.
					</p>

					<h3 className="privacy-policy-sub-title">4. Subscription and Payments</h3>
					<p className="privacy-policy-txt">
						Certain features may require a paid subscription. By subscribing, you agree to pay applicable fees.
					</p>
					<ul className="privacy-policy-list">
						<li><strong>eFlow Premium - Bronze</strong>: $1.99/month</li>
						<li><strong>eFlow Premium - Silver</strong>: $3.99/month</li>
					</ul>
					<p className="privacy-policy-txt">
						Subscriptions auto-renew unless canceled 24 hours before the end of the billing period. Management of subscriptions depends on your platform (e.g., Apple ID, Google Play).
					</p>

					<h3 className="privacy-policy-sub-title">5. Privacy and Data Collection</h3>
					<p className="privacy-policy-txt">
						Please review our <a href="/privacy">Privacy Policy</a> to understand how we collect, use, and store your information across all platforms, including Microsoft Teams.
					</p>

					<h3 className="privacy-policy-sub-title">6. Restrictions on Use</h3>
					<ul className="privacy-policy-list">
						<li>No reverse engineering, tampering, or modification of the App</li>
						<li>No automated data scraping</li>
						<li>No malware distribution or abuse</li>
					</ul>

					<h3 className="privacy-policy-sub-title">7. Service Availability</h3>
					<p className="privacy-policy-txt">
						We strive for consistent service, but availability is not guaranteed. Maintenance or unforeseen events may cause downtime.
					</p>

					<h3 className="privacy-policy-sub-title">8. Termination of Use</h3>
					<p className="privacy-policy-txt">
						We reserve the right to suspend or terminate access for violations or other concerns, at our sole discretion.
					</p>

					<h3 className="privacy-policy-sub-title">9. Third-Party Links</h3>
					<p className="privacy-policy-txt">
						Our App may include links to third-party services. We do not control or assume responsibility for their content or policies.
					</p>

					<h3 className="privacy-policy-sub-title">10. Disclaimers and Limitation of Liability</h3>
					<p className="privacy-policy-txt">
						The App is provided "as is" without warranties. eFlow is not liable for any damages arising from your use of the App, including through Microsoft Teams.
					</p>

					<h3 className="privacy-policy-sub-title">11. Indemnification</h3>
					<p className="privacy-policy-txt">
						You agree to indemnify and hold harmless eFlow against claims arising from your use of the App or violation of these Terms.
					</p>

					<h3 className="privacy-policy-sub-title">12. Governing Law</h3>
					<p className="privacy-policy-txt">
						These Terms are governed by the laws of Lebanon. Disputes shall be resolved in Lebanese courts unless otherwise required by law.
					</p>

					<h3 className="privacy-policy-sub-title">13. Contact Us</h3>
					<p className="privacy-policy-txt">
						If you have any questions, contact us at <span className="privacy-policy-email">support@eflow.app</span>.
					</p>

					<h3 className="privacy-policy-sub-title">14. Changes to the Terms</h3>
					<p className="privacy-policy-txt">
						We may update these Terms at any time. Your continued use after changes are posted indicates your acceptance.
					</p>

					<h3 className="privacy-policy-sub-title">15. Copyright and Trademarks</h3>
					<p className="privacy-policy-txt">
						All content is the property of eFlow Technologies Inc. and protected by applicable laws. Microsoft Teams is a trademark of Microsoft Corporation.
					</p>
				</div>
			</section>
			{width > 480 && <Footer />}
			{width < 480 && <MobileFooter />}
		</div>
	);
};

export default TermsOfUse;
